<template>
    <Modal :transfer="transfer" @on-visible-change="change" :fullscreen="fullscreen" scrollable :title="title" :value="show" :width="width"
           :styles="styles" :closable="closable" :mask-closable="maskClosable" @on-cancel="onCancel">
        <div slot="close" @click="onCancel">
            <Icon type="ios-close"></Icon>
        </div>
        <slot></slot>
        <div slot="footer" style="display: flex;justify-content: end">
            <slot name="buttons"></slot>
            <Button v-if="showCancel" @click="onCancel">{{$t(cancelText)}}</Button>
            <Button v-if="showConfirm &&!showExcelExport" type="primary" @click="onSubmit" :loading="loading">
                {{$t(confirmText)}}
            </Button>
            <template v-if="showConfirm && showExcelExport">
<!--                <download-excel-->
<!--                        class="export-excel-wrapper"-->
<!--                        :data="DetailsForm"-->
<!--                        type="xls"-->
<!--                        :fields="json_fields"-->
<!--                        name="电梯云平台注册电梯信息填写模板.xls">-->
                    <!-- 上面可以自定义自己的样式，还可以引用其他组件button -->
                    <Button type="primary" @click="downloadXls" :loading="loading">{{$t(confirmText)}}</Button>
<!--                </download-excel>-->
            </template>

        </div>
    </Modal>
</template>

<script>
    import {Modal} from "iview";
    import {utils,writeFile} from 'xlsx';
    export default {
        name: "lg-modal",
        props: {
            width: {
                default: 520
            },
          zIndex:{
            type: Number,
            default:1000
          },
          transfer:{
            type: Boolean,
            default:true
          },
            DetailsForm: {
                type: Array,
            },
            showExcelExport: {
                default: false
            },
            showCancel: {
                type: Boolean,
                default: true
            },
            closable: {
                type: Boolean,
                default: true
            },
            showConfirm: {
                type: Boolean,
                default: true
            },
            confirmText: {
                type: String,
                default: 'l.submit'
            },
            cancelText: {
                type: String,
                default: 'l.cancel'
            },
            loading: {
                type: Boolean,
                default: false
            },
            show: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: '窗口'
            },
            maskClosable: {
                type: Boolean,
                default: true
            },
            styles: {
                type: Object,
            },
            fullscreen: {
                type: Boolean
            }
        },
        data() {
          return {}
        },
      computed:{
        json_fields(){
          let param = {
            "电梯名称": "name",
            "电梯唯一工号": "yd_unique_code",
            "厂家代码": "code",
            "电梯型号": "model",
            "SIM卡ICCID": "iccid",
            "终端ID": "terminal_id",
            "设备代码": "equipment_code",
            "小区": "community_id",
            "总楼层": "j_floors",
            "品牌": "brand",
            // j_alarm_charger: [],
            "故障告警人1姓名": "alarm_name1",
            "故障告警人1电话": "alarm_mobile1",
            "故障告警人2姓名": "alarm_name2",
            "故障告警人2电话": "alarm_mobile2",
            "贯通门": "is_through_door",
            "维保公司": "mt_company_id",
            // j_mt_workers:[]
            "维保人1姓名": "mt_name1",
            "维保人1电话": "mt_mobile1",
            "维保人2姓名": "mt_name2",
            "维保人2电话": "mt_mobile2",
            "额定速度（m/s）": "speed",
            "额定载重（kg）": "load",
            "地址": "address",
            "备注": "remark"
          };
          // 判断是否是管理员
          let user = this.$store.state.user;
          //   2025年10月28日 王欢 按照姜铎和闵总沟通后的要求将中富电梯的厂家代码显示全部替换成电梯唯一工号
          let company = this.$store.state.user.user.company;
          if (user.isROOT) {
            param["可见电梯厂"]="factory_cid";
            return param;
          }
          if(company.id === 154 || company.pid === 154){
            delete param["厂家代码"];
            return param;
          }
          return param
        }
      },
        methods: {
            onCancel(e) {
                // e.stopPropagation();
                this.$emit('on-cancel')
            },
            onSubmit() {
                this.$emit('on-submit')
            },
            // onSubmitExport(){
            //   this.$emit('on-submit-export')
            // },
            change(e) {
                this.$emit('on-visible-change', e)
            },
          downloadXls() {
            // 1. 处理数据：将jsonData转换为带表头的二维数组（符合Excel结构）
            const header = Object.keys(this.json_fields); // 表头：['姓名', '年龄', '职业']
            const dataRows = this.DetailsForm.map(item => {
              return header.map(key => {
                let fieldKey = this.json_fields[key];
                if("is_through_door" === fieldKey){
                 if(item[fieldKey]  === 0){
                   return  "否";
                 } else{
                   return "是";
                 }
                }else if(fieldKey === "alarm_name1"){
                  let j_alarm_charger = JSON.parse(item.j_alarm_charger);
                  if(j_alarm_charger.length){
                    return j_alarm_charger[0].name;
                  }else{
                    return "";
                  }
                }else if(fieldKey === "alarm_name2"){
                  let j_alarm_charger = JSON.parse(item.j_alarm_charger);
                  if(j_alarm_charger.length && j_alarm_charger.length > 1){
                    return j_alarm_charger[1].name;
                  }else{
                    return "";
                  }
                }else if(fieldKey === "alarm_mobile1"){
                  let j_alarm_charger = JSON.parse(item.j_alarm_charger);
                  if(j_alarm_charger.length){
                    return j_alarm_charger[0].mobile;
                  }else{
                    return "";
                  }
                }else if(fieldKey === "alarm_mobile2"){
                  let j_alarm_charger = JSON.parse(item.j_alarm_charger);
                  if(j_alarm_charger.length && j_alarm_charger.length > 1){
                    return j_alarm_charger[1].mobile;
                  }else{
                    return "";
                  }
                }else if(fieldKey === "mt_name1"){
                  let j_mt_workers = JSON.parse(item.j_mt_workers);
                  if(j_mt_workers.length){
                    return j_mt_workers[0].name;
                  }else{
                    return "";
                  }
                }else if(fieldKey === "mt_name2"){
                  let j_mt_workers = JSON.parse(item.j_mt_workers);
                  if(j_mt_workers.length && j_mt_workers.length>1){
                    return j_mt_workers[1].name;
                  }else{
                    return "";
                  }
                }else if(fieldKey === "mt_mobile1"){
                  let j_mt_workers = JSON.parse(item.j_mt_workers);
                  if(j_mt_workers.length){
                    return j_mt_workers[0].mobile;
                  }else{
                    return "";
                  }
                }else if(fieldKey === "mt_mobile2"){
                  let j_mt_workers = JSON.parse(item.j_mt_workers);
                  if(j_mt_workers.length && j_mt_workers.length>1){
                    return j_mt_workers[1].mobile;
                  }else{
                    return "";
                  }
                }
                return item[fieldKey];
              }); // 按表头顺序提取数据
            });
            console.log("dataRows:",dataRows);
            const excelData = [header, ...dataRows]; // 合并表头和数据
            console.log("this.DetailsForm:",this.DetailsForm);
            // 2. 用js-xlsx生成.xls文件
            const worksheet = utils.aoa_to_sheet(excelData); // 数组转工作表
            const workbook = utils.book_new();
            utils.book_append_sheet(workbook, worksheet, 'sheet1');
            // 3. 生成并下载.xls文件（指定bookType为xls）
            writeFile(workbook, '电梯云平台注册电梯信息填写模板.xls', { bookType: 'xls' });
          }
        }
    }
</script>

<style scoped>
    .export-excel-wrapper{
        margin-left: 10px;
    }
</style>